import { __debug } from "../Debug/Debug";
import { __utils } from "../Utils";

/**
 * Callback class
 */
export class CallbackManager {

    private name: string = "";
    private callbacks: any = {};
    private warnings: boolean = true;


    /**
     * Manages callback functions
     * @param {string} name
     * @param {boolean=} warnings
     * 
     */
    constructor(name: string, warnings: boolean = true) {
        this.name = name;
        this.warnings = warnings;
    }

    /**
     * registers a callback
     * @param {Function} callback
     * @returns {string} returns a uniqu id
     */
    register = (callback: Function) => {
        const id = __utils.getRandomIdShort();
        this.callbacks[id] = callback;
        return id;
    }
    /**
     * triggers the callbacks registered via the (registerCallback) method
     * @param {any} data
     * @returns {void} returns nothing
     */
    trigger = (data: any) => {
        if (this.isEmpty()) {
            if (!this.warnings) return;
            __debug.warn(() => {
                console.warn(`No callbacks registered for: [${this.name}]`);
            });
            return;
        }
        // trigger callbacks
        Object.keys(this.callbacks).forEach(id => {
            this.callbacks[id](data);
        });
    }

    /**
     * determines if there are no callback registered.
     * @returns {boolean} true or false
     */
    isEmpty = () => {
        return (Object.keys(this.callbacks).length === 0)
    }

    /**
     * removes the callback
     * @param {string} id 
     */
    remove = (id: string) => {
        delete this.callbacks[id];
    }

}

